export default __webpack_public_path__ + "static/media/Pfizer.d98d2346.png";